export class InboxFilter {
    constructor( ) {
        this.campaignId = null;
        this.emailAccount = null;
        this.campaignStageId = null;
        this.status = null;
        this.hasEmail = null;
        this.page = 1;
    }
}